import React, { useEffect, useState } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { fetchTokenWithCode } from './bbOauthService';
import { getUserToken, setUserToken } from '../authSlice';
import { useTranslation } from 'react-i18next';
import stringsCy from '../locales/strings.cy.json';
import stringsEn from '../locales/strings.en.json';
import { Alert } from 'react-bootstrap';

export const BBLogin: React.FC = () => {
  const { search, state } = useLocation();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => getUserToken(state));

  const [code, setCode] = useState<string>();
  const [error, setError] = useState<{status: number, message?: string}>();
  
  const {t:_} = useTranslation();
  const { i18n } = useTranslation();
  i18n.addResources("cy", "translation", stringsCy);
  i18n.addResources("en", "translation", stringsEn);

  const redirect = localStorage.getItem('callback-url') ?? "/"

  useEffect(() => {
    if (state?.from?.pathname) {
      localStorage.setItem('callback-url', state.from.pathname)
    } else {
      if (token) {
        localStorage.removeItem('callback-url');
      } 
    }
  }, [state, token, redirect])

  useEffect(() => {
  if (token) return;
    const endpoint = `${process.env.REACT_APP_RESOURCES_API_URL}bbauth/login?bb_client_id=${process.env.REACT_APP_BB_CLIENT_ID}`;
    if (!search) window.location.replace(endpoint);
    setCode(search.split('=')[1]);
  }, [search, token]);

  useEffect(() => {
    if (!code || token) return;
    fetchTokenWithCode(code)
      .then((userToken) => {
        if (userToken) dispatch(setUserToken(userToken));
      })
      .catch((error) => {
        let message: string|undefined;

        if (error?.status === 403) {
            message = _("login_403")
        } else {
            message = _("login_500")
        }
        
        setError({status: error.status, message: message})
      });
  }, [code, dispatch, token, _]);

  return error ? (
    <Alert
      variant="danger"
      className="position-absolute top-50 start-50 translate-middle"
    >
      <h3 data-testid="error">{_("Error")}</h3>
      {"status" in error && (
          <>
              <p>
                  {_("Error code")}: {error.status}{" "}
              </p>
              <p>{error.message}</p>
          </>
      )}
      <Link to={redirect}>{_("Back")}</Link>
    </Alert>
  )
  : token 
  ? <Navigate to={redirect} /> 
  : <p>{_("Loading")}...</p>
};
